import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
import openApp from '@ivy/fts/openApp';
import { isXcxWeb } from '@ivy/fts/utils';
let ChannelDetailIntro = class ChannelDetailIntro extends Vue {
    constructor() {
        super(...arguments);
        this.isXcxWeb = isXcxWeb();
        this.limitTime = [];
    }
    mounted() {
        this.intro && this.intro.activity.id && ['limit_buy', 'group', 'limit_free'].includes(this.intro.activity.activity_type) && this.countdown(this.intro.activity.end_time);
    }
    goApp() {
        openApp();
    }
    countdown(end) {
        end = end.replace(/\-/g, '/');
        // 相差的毫秒数
        const msec = new Date(end).getTime() - new Date().getTime();
        if (msec <= 0)
            return this.$router.go(0);
        let remainTime = Date.formatMs(msec, "DD hh mm ss");
        this.remainTime = remainTime;
        this.limitTime = remainTime.split(" ");
        // 一秒后递归
        setTimeout(() => {
            this.countdown(end);
        }, 1000);
    }
    showCoupon() {
        this.$emit('showCoupon');
    }
};
tslib_1.__decorate([
    Prop()
], ChannelDetailIntro.prototype, "intro", void 0);
tslib_1.__decorate([
    Prop()
], ChannelDetailIntro.prototype, "hasBought", void 0);
tslib_1.__decorate([
    Prop()
], ChannelDetailIntro.prototype, "hasCoupon", void 0);
tslib_1.__decorate([
    Prop()
], ChannelDetailIntro.prototype, "couponList", void 0);
ChannelDetailIntro = tslib_1.__decorate([
    Component({
        filters: {
            seperatePrice(price) {
                if (!price)
                    return {};
                let prices = price.toString().split('.');
                return { integer: prices[0], decimal: prices[1] };
            },
            integerPrice(price) {
                return price.integer;
            },
            decimalPrice(price) {
                return price.decimal;
            }
        }
    })
], ChannelDetailIntro);
export default ChannelDetailIntro;
